export default {
    createCashOutRecord:
        "/gateway/huilianOperation/cashOutcs/createCashOutRecord", // 新增提现记录
    pinganActivityUserCash:
        "/gateway/huilianOperation/hoPinganActivitycs/pinganActivityUserCash", // 用户平安金余额
    selectBankInfoList:
        "/gateway/huilianCust/hcAccountBankInfocs/selectBankInfoList", // 银行卡查询
};



// WEBPACK FOOTER //
// ./src/withdrawal/index/api.js